import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

function Loader({
  classNameWrapper,
  spinSize,
  isSpinning
}: {
  classNameWrapper?: string;
  spinSize: number;
  isSpinning: boolean;
}) {
  const antIcon = <LoadingOutlined style={{ fontSize: spinSize }} spin />;

  return (
    <div className={classNameWrapper}>
      <Spin indicator={antIcon} spinning={isSpinning} />
    </div>
  );
}

export default Loader;
